export enum ScheduledPaymentUseDateAsEnum {
  THIS_DATE = 'THIS_DATE',
  LAST_DATE = 'LAST_DATE'
}
